import classNames from 'classnames'
import * as React from 'react'

import {headerAdministrationLinkHint} from '../../../../packages/Hints/HintItems/Hints.navigation'
import {useHint} from '../../../../packages/Hints/Hints.hooks'
import {LINKS} from '../../Header.consts'
import HeaderLinkHost from '../LinkHost/LinkHost'
import styles from '../Links.css'

function AdministrationLink() {
  useHint(headerAdministrationLinkHint)
  const isActive = document.location.pathname.includes('/admin/')
  return (
    <div
      className={classNames(styles.container, styles.administration)}
      data-hint-container-id={headerAdministrationLinkHint.id}
    >
      <HeaderLinkHost
        className={styles.link}
        title={'Administration'}
        to={LINKS.administration}
        active={isActive}
      >
        {'Administration'}
      </HeaderLinkHost>
    </div>
  )
}

export default React.memo(AdministrationLink)
